/**
 * Theme configuration for CaseFiles
 * Contains background gradients and accent colors for each theme
 */

export const DEFAULT_THEME = '90s_nyc';

export const themeConfig = {
  noir: { bg: 'from-slate-900 to-slate-800', accent: '#DC143C' },
  '90s_nyc': { bg: 'from-gray-900 to-black', accent: '#FF6B35' },
  miami_vice: { bg: 'from-gray-900 to-black', accent: '#FF1493' },
  vice: { bg: 'from-gray-900 to-black', accent: '#FF1493' }, // Alias for miami_vice
};
